import styled from 'styled-components';

export const Button = styled.div`
position: fixed;
width:5%;
right: 0%;
bottom: 40px;
height: 50px;
font-size: 3.0rem;
z-index: 1;
cursor: pointer;
color:#D90429;
`
